<template>
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7.5" cy="8" r="7" stroke="#D0D0D5"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.4875 6.71429C8.61875 6.58571 8.75 6.25143 8.75 6.07143C8.75 5.73044 8.6183 5.40341 8.38388 5.16229C8.14946 4.92117 7.83152 4.78571 7.5 4.78571C7.16848 4.78571 6.85054 4.92117 6.61612 5.16229C6.3817 5.40341 6.25 5.73044 6.25 6.07143H5C5 5.38944 5.26339 4.73539 5.73223 4.25315C6.20107 3.77092 6.83696 3.5 7.5 3.5C8.16304 3.5 8.79893 3.77092 9.26777 4.25315C9.73661 4.73539 10 5.38944 10 6.07143C10 6.59857 9.73125 7.25429 9.375 7.62714L8.3875 8.64286C8.25625 8.77143 8.125 9.09929 8.125 9.28571V9.92857H6.875V9.28571C6.875 8.75857 7.14375 8.10286 7.5 7.73L8.4875 6.71429ZM6.875 12.5V11.2143H8.125V12.5H6.875Z" fill="black"/>
  </svg>
</template>

<script>
  export default {
    name: "QuestionBackground"
  }
</script>

<style scoped>

</style>